import React from 'react';
import DModal from '@/components/Global/DModal';
import DButton from '@/components/Global/DButton';
import CheckmarkIcon from '@/components/Global/Icons/CheckmarkIcon';
import useWelcomeBackModalStore from '@/stores/welcomeBackModal/welcomeBackModalStore';
import WelcomeBackBG from "../../assets/modal/welcomeBackBG.png"
import CloseIcon from '../Global/Icons/CloseIcon';

const WelcomeBackCampaignModal = () => {
  const {
    isOpen,
    isLoading,
    handleAcceptOffer,
    handleClose,
    checkModalStatus,
    setIsOpen
  } = useWelcomeBackModalStore();

  // Plan configuration - can be moved to props or store
  const planConfig = {
    name: 'Starter',
    price: '$9',
    period: 'per week',
    buttonText: 'Go Starter',
    features: [
      { name: 'Build 5 AI Voice Agents', isNew: true },
      { name: 'Access to fast LLM models', isNew: false },
      { name: '12,000 messages/month', isNew: false },
      { name: '5 AI chatbots', isNew: false },
      { name: '0 team member seats', isNew: false },
      { name: 'Realtime AI voice access', isNew: false },
      { name: 'Custom styling and personalities', isNew: false },
      { name: 'Embed unlimited websites', isNew: false },
      { name: 'Unlimited links to train on', isNew: false },
      { name: 'Unlimited files to train on', isNew: false },
      { name: 'Chat records', isNew: false },
      { name: 'Enhanced chatbot security', isNew: false },
      { name: '100+ languages', isNew: false },
      { name: 'Zapier integration', isNew: false },
      { name: 'Advanced analytics', isNew: false },
      { name: 'Priority email support', isNew: false }
    ]
  };

  return (
    <DModal
      isOpen={isOpen}
      onClose={handleClose}
      className="max-w-[500px] mx-4 sm:mx-auto !p-0"
      hideCloseButton={false}
      contentBgColor="bg-white !p-0"
      headerClassName= "hidden"
    >
      <div className="relative flex flex-col items-center text-center space-y-4 sm:space-y-6 w-full  max-w-[500px] md:w-[500px] px-0 pb-4">
         <button className='absolute top-4 right-4' onClick={handleClose}>
          <CloseIcon className=" text-white" />
         </button>
        <img src={WelcomeBackBG} alt="" className='w-full !mt-0 h-[150px] object-cover'/>
        <div className="space-y-2 px-4">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 pb-2">
           Try our Starter Plan
          </h2>
          <p className="text-gray-600 text-sm">
           $1 reactivation offer is only available right now.
          </p>
        </div>
   
        <div className="w-full text-left sm:space-y-4 px-4">
    

       
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm px-4">
            <div className="flex flex-col gap-[0.4rem]">
               
              <div className="text-center">
                <h3 className="text-xl font-medium mb-0.5">{planConfig.name}</h3>
              </div>


              {/* Features List */}
              <div className="flex flex-col gap-size0 mt-size2">
                <div className="grid grid-cols-2 gap-x-4">
                  {/* Left Column - First 8 items */}
                  <ul className="flex flex-col gap-[0.15rem]">
                    {planConfig.features.slice(0, 8).map((feature, index) => (
                      <li key={index} className="flex items-left gap-size1">
                        <div className="w-3 flex items-center justify-center">
                          <CheckmarkIcon
                            width={20}
                            height={20}
                            className="text-purple-400 w-3 h-3"
                          />
                        </div>
                        <div className="flex items-center gap-size1">
                          <span className="text-xs leading-[1.7]">
                            <div className="flex items-center gap-1">
                              {feature.name}
                              {feature.isNew && (
                                <div className="h-4 px-1.5 rounded-full font-medium inline-flex items-center justify-center text-white text-xs ml-1" style={{background: 'linear-gradient(87deg, rgb(100, 116, 255) -15.34%, rgb(128, 120, 253) 21.77%, rgb(207, 120, 254) 83.94%)', boxShadow: 'rgba(207, 120, 254, 0.3) 0px 2px 4px'}}>
                                  <span className="text-white leading-none">New</span>
                                </div>
                              )}
                            </div>
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>

                  {/* Right Column - Last 8 items */}
                  <ul className="flex flex-col gap-[0.15rem]">
                    {planConfig.features.slice(8, 16).map((feature, index) => (
                      <li key={index + 8} className="flex items-left gap-size1">
                        <div className="w-3 flex items-center justify-center">
                          <CheckmarkIcon
                            width={20}
                            height={20}
                            className="text-purple-400 w-3 h-3"
                          />
                        </div>
                        <div className="flex items-center gap-size1">
                          <span className="text-xs leading-[1.7]">
                            <div className="flex items-center gap-1">
                              {feature.name}
                              {feature.isNew && (
                                <div className="h-4 px-1.5 rounded-full font-medium inline-flex items-center justify-center text-white text-xs ml-1" style={{background: 'linear-gradient(87deg, rgb(100, 116, 255) -15.34%, rgb(128, 120, 253) 21.77%, rgb(207, 120, 254) 83.94%)', boxShadow: 'rgba(207, 120, 254, 0.3) 0px 2px 4px'}}>
                                  <span className="text-white leading-none">New</span>
                                </div>
                              )}
                            </div>
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

     
        <div className="w-full space-y-3 px-4">

          <DButton
            variant="dark"
            fullWidth={true}
            className="!h-12 "
            onClick={handleAcceptOffer}
            loading={isLoading}
            disabled={isLoading}
          >
            Unlock Everything for Just $1
          </DButton>
        </div>
       
      </div>
    </DModal>
  );
};

export default WelcomeBackCampaignModal;
